import { render, staticRenderFns } from "./Diada.vue?vue&type=template&id=c7e27e80&lang=pug&"
import script from "./Diada.vue?vue&type=script&lang=js&"
export * from "./Diada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports